function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6389 9.51096C10.6389 8.81511 10.0748 8.25101 9.37891 8.25101C8.68305 8.25101 8.11895 8.81511 8.11895 9.51096L10.6389 9.51096ZM8.48799 11.1019C8.98003 11.5939 9.77779 11.5939 10.2698 11.1019L18.2881 3.08357C18.7802 2.59153 18.7802 1.79377 18.2881 1.30173C17.7961 0.809688 16.9983 0.809688 16.5063 1.30173L9.37891 8.4291L2.25154 1.30173C1.7595 0.809688 0.961741 0.809688 0.4697 1.30173C-0.0223429 1.79377 -0.022343 2.59153 0.4697 3.08357L8.48799 11.1019ZM8.11895 9.51096L8.11895 10.2109L10.6389 10.2109L10.6389 9.51096L8.11895 9.51096Z",
  fill: "white"
});

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.9d27d71a.svg";
export { ForwardRef as ReactComponent };